module.exports = __webpack_public_path__ + "img/5-1-levy.581107de.jpg";